var _paymentTypeName;

import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var PAYMENT_DOCUMENT_STATUS = {
  waiting_sign: 'waiting_sign',
  signed: 'signed'
};
export var PAYMENT_DOCUMENT_TYPE = {
  payment: 'payment',
  payment_revert: 'payment_revert'
};
export var PAYMENT_TYPE = {
  cash: 'cash',
  bank: 'bank'
};
export var paymentTypeName = (_paymentTypeName = {}, _defineProperty(_paymentTypeName, PAYMENT_TYPE.cash, 'В брой'), _defineProperty(_paymentTypeName, PAYMENT_TYPE.bank, 'По банков път'), _paymentTypeName);
export var paymentTypeOptions = [{
  label: 'В брой',
  value: PAYMENT_TYPE.cash
}, {
  label: 'По банков път',
  value: PAYMENT_TYPE.bank
}];